import { render, staticRenderFns } from "./attributes.vue?vue&type=template&id=4b45461c&"
import script from "./attributes.vue?vue&type=script&lang=js&"
export * from "./attributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports